import { render, staticRenderFns } from "./SampleModalConfirmation.vue?vue&type=template&id=af6ac3f4&scoped=true"
import script from "./SampleModalConfirmation.vue?vue&type=script&lang=js"
export * from "./SampleModalConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SampleModalConfirmation.vue?vue&type=style&index=0&id=af6ac3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ac3f4",
  null
  
)

export default component.exports